/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
/**
 * Get preferred languages detected from from browser
 */
var BrowserLanguageDetector = /** @class */ (function () {
    function BrowserLanguageDetector() {
    }
    BrowserLanguageDetector.prototype.detect = function () {
        var found = [];
        var navigator = window.navigator;
        if (typeof navigator !== 'undefined') {
            var userLanguage = navigator.userLanguage;
            var language = navigator.language;
            if (navigator.languages) {
                // chrome only; not an array, so can't use .push.apply instead of iterating
                for (var i = 0; i < navigator.languages.length; i++) {
                    found.push(navigator.languages[i]);
                }
            }
            if (userLanguage) {
                found.push(userLanguage);
            }
            if (language) {
                found.push(language);
            }
        }
        return found;
    };
    return BrowserLanguageDetector;
}());
export default BrowserLanguageDetector;
